import React from 'react'
import PropTypes from 'prop-types'

const TableColumn = ({ children, align = 'left', classes, onClick, width, colSpan = 1, style }) => (
  <td
    className={classes}
    align={align}
    width={width}
    onClick={onClick}
    colSpan={colSpan}
    style={style}
  >
    {children}
  </td>
)

TableColumn.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
  align: PropTypes.string,
  width: PropTypes.string,
  onClick: PropTypes.func,
  colSpan: PropTypes.number,
  style: PropTypes.object,
}

export default TableColumn
